import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Scrollbar from "react-scrollbars-custom";

import config from "config/common";
import lib from "lib/commons";
import Spinner from "components/Spinner";

Modal.setAppElement("#root");

const ModalHistory = ({
  userHistory,
  isGettingHistory,
  getHistory,
  modalStatus,
  closeModal,
}) => {

  useEffect(() => {
    if (!isGettingHistory) {
      getHistory();
    }
  }, []);

  const afterOpenModal = () => {};

  const selfClose = (event) => {
    event.preventDefault();
    closeModal();
  };

  // TODO: delete when deploy
  // isGettingHistory = false

  // userHistory = [
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  //   {
  //     reward_name: "Testing VP 1",
  //     status: "Nhan",
  //     create_time: "2025-10-10 12:00:00",
  //     usage: "daily_success"
  //   },
  // ]

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-history"
    >
      <div className="modal-description">
        <h2>Lịch sử</h2>
            {isGettingHistory ? (
              <Spinner />
            ) : (
              <>
                <table className="table-history">
                  <thead>
                    <tr>
                      <th width="10%">STT</th>
                      <th width="30%">Tên VP</th>
                      <th width="15%">Trạng thái</th>
                      <th width="25%">Thời gian</th>
                      <th width="20%">Sự kiện</th>
                    </tr>
                  </thead>
                </table>

                <Scrollbar style={{ height: "29vw" }} noScrollX={true}>
                  {userHistory.length > 0 ? (
                    <table className="table-history">
                      <tbody>
                        {userHistory.map((his, index) => (
                          <tr key={index}>
                            <td width="10%">
                              <strong>{index + 1}</strong>
                            </td>
                            <td width="30%">{his.reward_name}</td>
                            <td width="15%">{his.status}</td>
                            <td width="25%">{his.create_time}</td>
                            <td width="20%">
                              {his.usage == "daily_success" ? "Quà sút vào" : his.usage == "daily_failure" ? "Quà sút không vào" : "Quà tích luỹ"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>Chưa có lịch sử</p>
                  )}
                </Scrollbar>
              </>
            )}

      </div>
      <a
        onClick={(event) => selfClose(event)}
        className="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        ×
      </a>
    </Modal>
  );
};
export default ModalHistory;
